module.exports = __webpack_public_path__ + "static/img/guide02.6f1a5aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c17/guide02.png
// module id = Sb6R
// module chunks = 0